import { apiCall } from "./authServices";


export const fetchDonutDetails = async () => {
  try {
    const response = await apiCall({
      endpoint: "api/admin-dashboard/courses-overview",
      method: "GET",
    });
    return response 
  } catch (error) {
    console.error("Error fetching course categories:", error);
    throw error;
  }
};